import React from 'react';
import { Drawer } from 'antd';
import menuItems from 'menu-items';
import { useStyles } from './index.style';
import Menu from '../SiderMenu/menu';
import LogoSection from '../LogoSection';

interface IHookProps {
  onClose: () => void;
  open: boolean;
}

const Sidebar: React.FC<IHookProps> = ({ open, onClose }) => {
  const { styles } = useStyles();
  return (
    <Drawer placement="left" onClose={() => onClose()} open={open} width={280} closeIcon={null}>
      <div style={{}}>
        <LogoSection />
        <div className={styles.menuContainer}>
          {menuItems.items.map((x) => {
            return <Menu key={x.title} data={x} />;
          })}
        </div>
      </div>
    </Drawer>
  );
};

export default Sidebar;
